module.exports = __webpack_public_path__ + "img/arrow_pink.badc97ff.svg";